var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIllustrations.js
import * as React from 'react';
import IllustrationContainer from '../IllustrationContainer.js';

function CloseIllustration(props) {
  return /*#__PURE__*/React.createElement(IllustrationContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M64 126c34.242 0 62-27.758 62-62 0-34.242-27.758-62-62-62C29.758 2 2 29.758 2 64c0 34.242 27.758 62 62 62z",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M38.826 31.756l-7.071 7.071a2 2 0 000 2.829l54.517 54.517a2 2 0 002.829 0l7.07-7.07a2 2 0 000-2.83L41.655 31.757a2 2 0 00-2.828 0z",
      fill: "#009CEB"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M95.83 39.485l-7.07-7.07a2 2 0 00-2.829 0L31.414 86.931a2 2 0 000 2.828l7.071 7.071a2 2 0 002.828 0l54.518-54.517a2 2 0 000-2.829z",
      fill: "#009CEB"
    })))
  }));
}

export default CloseIllustration;